import type { State } from '../../../state'
import type { ActivityDetails } from '../../../typings'

export const fetchAllActivitiesProducer = (
  state: State,
  payload: ActivityDetails[],
): State => {
  return {
    ...state,
    activities: payload,
  }
}
